<template>
  <div class="place-an-order">
    <div class="banner" v-if="goodsMasterImageUrl">
      <img :src="goodsMasterImageUrl" />
    </div>
    <div
      class="order-wrapper"
      :style="{ backgroundColor: currentColorConfig.backgroundColor }"
      id="btn"
      ref="btn"
    >
      <div
        class="carousel"
        :style="{
          justifyContent:
            !currentFormConfig.roll &&
            currentFunctionConfig.isDisplaySalesVolume
              ? 'flex-end'
              : 'space-between',
        }"
        v-if="currentFormConfig.roll || currentFunctionConfig.salesVolume"
      >
        <div class="scrollContainer" v-if="currentFormConfig.roll">
          <div class="iconLeft">
            <img src="../../assets/tip.png" />
          </div>
          <div class="scrollRight">
            <van-swipe
              :autoplay="2000"
              :show-indicators="false"
              :touchable="false"
              :vertical="currentFormConfig.rollStyle === 1"
              style="height: 40px"
            >
              <van-swipe-item
                class="content"
                v-for="(item, index) in listContent"
                :key="index"
              >
                <p>
                  10秒钟前...<span>{{ item }}</span
                  >刚刚下单
                </p>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>

        <div class="sales" v-if="currentFunctionConfig.isDisplaySalesVolume">
          已有<span>{{ currentFunctionConfig.salesVolume }}</span
          >人申请
        </div>
      </div>
      <div class="order">
        <div
          class="goods_title"
          :class="{ 'text-center': currentFormConfig.titleCenter }"
          :style="{ color: currentColorConfig.titleColor }"
        >
          {{ currentTextConfig.isFolding }}
        </div>
        <van-form>
          <van-field
            v-model="order.receiverName"
            center
            name="您的姓名"
            :label="
              orderData.idCardRuleSaveVO &&
              orderData.idCardRuleSaveVO.haveIdCard
                ? '身份证姓名：'
                : '您的姓名：'
            "
            placeholder="请输入姓名"
            class="field-top"
          />
          <van-field
            v-if="
              orderData.idCardRuleSaveVO &&
              orderData.idCardRuleSaveVO.haveIdCard
            "
            v-model="order.receiverIdCard"
            center
            maxlength="18"
            name="身份证号"
            label="身份证号："
            placeholder="请输入身份证号码"
            class="field-top"
            @input="handleIdCardInput"
          >
          </van-field>
          <van-field
            v-model="order.receiverMobile"
            center
            name="手机号码"
            label="手机号码："
            type="tel"
            placeholder="请输入手机号"
            maxlength="11"
            @input="handleMobileInput"
          />
          <template
            v-if="
              (currentFormConfig.fold && order.receiverMobile.length === 11) ||
              !currentFormConfig.fold
            "
          >
            <van-field
              v-model="order.smsCode"
              center
              name="短信验证码"
              label="短信验证码："
              type="number"
              placeholder="请输入短信验证码"
              maxlength="4"
            >
              <template #button>
                <van-button
                  style="width: 9em"
                  @click="handleGetSmsCode"
                  :disabled="isCountingDown"
                  size="mini"
                  type="primary"
                  class="code_btn"
                >
                  {{
                    isCountingDown ? `${countdown}秒后重新获取` : "获取验证码"
                  }}
                </van-button>
              </template>
            </van-field>
            <van-field
              center
              readonly
              clickable
              name="area"
              :value="value"
              label="所在地区："
              placeholder="点击选择省市区"
              @click="showArea = true"
            >
              <template #button>
                <div class="area-button-box">
                  <van-icon
                    @click.stop="clearValue"
                    v-show="value"
                    name="close"
                  />
                </div>
              </template>
            </van-field>
            <van-popup v-model="showArea" position="bottom">
              <van-area
                :area-list="areaList"
                @confirm="onConfirm"
                @cancel="showArea = false"
              />
            </van-popup>
            <van-field
              v-model="order.receiverAddress"
              type="textarea"
              name="详细地址"
              label="详细地址："
              placeholder="如街道、小区门牌等详细地址"
            />
          </template>
        </van-form>

        <van-checkbox
          v-model="checked"
          icon-size="14px"
          shape="square"
          class="search-check search-agreement"
          checked-color="#ee0a24"
        >
          我已阅读并同意
          <span @click.stop="agreementClick">《入网许可协议》</span>
          <span @click.stop="noticeClick">《个人信息收集证明》</span>

          <span @click.stop="personalInformationClick"
            >《个人信息保护政策》</span
          >
          <span @click.stop="letterOfAgreementClick">《单独同意书》</span>
          <span @click.stop="policyClick">《隐私政策》</span>
        </van-checkbox>
        <div class="btn-wrapper">
          <van-button
            type="danger"
            class="place-btn"
            @click="placeOrder"
            :class="{ 'btn-animate': currentFunctionConfig.btnStatus === 0 }"
            :style="{
              backgroundColor: currentColorConfig.btnColor,
              borderColor: currentColorConfig.btnColor,
            }"
          >
            {{ currentTextConfig.btnText || "提交申请" }}
          </van-button>
        </div>
      </div>
    </div>
    <!-- 底部图片 -->
    <div class="bottom_banner">
      <picture v-for="(item, index) in goodsImageUrls" :key="index">
        <img :src="item" />
      </picture>
    </div>
    <!-- 协议 -->
    <AgreementPopup ref="agreementPopup" />
    <!-- 协议二 -->
    <NoticePopup ref="noticePopup" />
    <policyPopup ref="policyPopup" />
    <personalInformationPopup ref="personalInformationPopup" />
    <letterOfAgreementPopup ref="letterOfAgreementPopup" />
    <!-- 上传身份证实例 -->
    <IdCardUploadPopupExample
      ref="idCardUploadPopupExample"
      :types="identityCardImageTypes"
    />

    <van-popup
      v-model="submittedRedirectPopupVisible"
      style="background-color: transparent; width: 100%"
      :close-on-click-overlay="false"
    >
      <div class="redirect-img">
        <van-icon
          @click="hideRedirectPopup"
          class="redirect-img-close"
          name="cross"
          :size="22"
        />
        <img :src="submittedRedirectImgUrl" @click="handleSubmittedImgUrl" />
      </div>
    </van-popup>
    <div class="fixed-btn" v-show="fixedBtnShow">
      <van-button
        type="danger"
        class="place-btn"
        @click="scrollToForm"
        :class="{ 'btn-animate': currentFunctionConfig.btnStatus === 0 }"
        :style="{
          backgroundColor: currentColorConfig.btnColor,
          borderColor: currentColorConfig.btnColor,
        }"
      >
        {{ currentTextConfig.btnText || "提交申请" }}
      </van-button>
    </div>
    <van-popup
      v-model="alertVisible"
      style="background-color: transparent; width: 100%"
      :close-on-click-overlay="false"
    >
      <div class="alertPopup">
        <div class="alertText">{{ alertVisibleText }}</div>
        <van-button type="danger" class="btn" @click="closeAlertPopup"
          >确认</van-button
        >
      </div>
    </van-popup>
    <van-popup
      v-model="payVisible"
      :close-on-click-overlay="false"
      position="bottom"
      round
      closeable
      class="payAlert"
    >
      <div class="title">支付金额</div>
      <div class="money">
        {{ this.orderData.sellingPrice }}<span class="unit">元</span>
      </div>
      <div class="alertPayPopup">
        <div class="payRadioWrapper">
          <van-radio-group v-model="checkedPay">
            <van-radio name="1" label-position="left">
              <img src="@/assets/wxpay.png" class="pay-img" />微信支付
            </van-radio>
            <div
              style="
                width: 90%;
                height: 1px;
                margin: 15px auto;
                background-color: #ebebeb;
              "
            ></div>
            <van-radio name="2" label-position="left">
              <img src="@/assets/alipay.png" class="pay-img" />支付宝支付
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="payBtnWrapper">
        <van-button
          type="danger"
          class="btn"
          :disabled="forbidden"
          @click="placeOrderTwo"
          >确认订单</van-button
        >
      </div>
    </van-popup>

    <van-popup
      v-model:show="showDelist"
      round
      style="padding: 34px"
      :close-on-click-overlay="false"
      >该商品已下架</van-popup
    >
    <ul class="homeAction">
      <li
        class="homeActionItem"
        v-if="currentFunctionConfig.complaintFeedback"
        @click="goLink('report')"
      >
        <img src="../../assets/homeTS.png" class="homeActionIcon" />
        投诉反馈
      </li>
      <li
        class="homeActionItem"
        v-if="currentFunctionConfig.myOrders"
        @click="goLink('order')"
      >
        <img src="../../assets/homeDD.png" class="homeActionIcon" />
        我的订单
      </li>
      <li
        class="homeActionItem"
        v-if="currentFunctionConfig.contactService"
        @click="goKf()"
      >
        <img src="../../assets/homeKF.png" class="homeActionIcon" />
        联系客服
      </li>
    </ul>
    <!-- 短信验证码弹窗 -->
    <van-dialog
      v-model:show="smsCodeDialogShow"
      title=""
      show-cancel-button
      @confirm="handleConfirm"
      @cancel="handleCancel"
    >
      <div class="dialog_content">
        <van-field
          v-model="order.code"
          center
          name="验证码"
          type="number"
          placeholder="请输入验证码"
          maxlength="4"
        >
          <template #button>
            <img
              v-if="order.captchaSrc"
              :src="order.captchaSrc"
              alt="captcha"
              class="dialog_code_image"
              @click="buildCaptcha"
            />
          </template>
        </van-field>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  order,
  apiGetTransitFlag,
  getGoodsDetail,
  loadCaptcha,
  submitOrder,
  getPhoneSmsCode,
} from "@/api/api";
import IdCardUploadPopupExample from "./modules/IdCardUploadPopupExample.vue";
import AgreementPopup from "./modules/AgreementPopup.vue";
import NoticePopup from "./modules/NoticePopup.vue";
import { checkIdCard, randomNum } from "@/utils";
import Compressor from "compressorjs";
import letterOfAgreementPopup from "./modules/letterOfAgreementPopup";
import personalInformationPopup from "./modules/personalInformationPopup";
import policyPopup from "./modules/policyPopup";

let timer = null; //定义自动跳转延时器
//监听浏览器关闭事件
const obj = {
  failJumpTreeFlag: false, //判断是否跳转
  judgmentOrder: false, //判断是否下单
};
// 定义一个obj变量监听器
const handler = {
  set(target, key, value) {
    target[key] = value;
    return true;
  },
};
// 创建一个Proxy对象来监听obj变量的变化
const proxyObj = new Proxy(obj, handler);

//监听离开或关闭页面的方法
window.addEventListener(
  "popstate",
  function (e) {
    if (obj.failJumpTreeFlag && !obj.judgmentOrder) {
      window.history.back();
      skipInfo("home_leave");
    }
  },
  false
);
//改方法添加了一个历史记录，路径为#，保证了不刷新页面，不直接后退。
function pushHistory() {
  var state = {
    title: "title",
    url: "#",
  };
  window.history.pushState(state, "title", "#");
}
//添加跳转信息函数
function skipInfo(pointNum) {
  // 初始化sdk
  let time = new Date().getTime();
  let random = Math.floor(Math.random() * (999999 - 1 + 1) + 1); // 生成范围在[1, 999999]内的随机整数
  let sessionId = time + "" + random;
  const sdk = recsdk.init({
    sessionId: sessionId,
    unionKey: "d465bad1c3254033aaf46fe37d875047",
  });
  // 调用获取推荐产品，获取成功后自动跳转连接
  sdk.getAd(
    {
      isp: "ISP-CMCC",
      phoneNum: "",
      phoneProvince: "",
      ErrCode: "",
      errMsg: "",
      Media: "",
      pointNum,
    },
    (err) => {
      // 获取失败的回调 - 可自行处理错误流程
      console.log("err==>", err);
    }
  );
  clearTimeout(timer);
  timer = null;
}
const imgCompressor = function (
  file,
  maxWidth = 1000,
  maxHeight = 1000,
  quality = 0.8
) {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality,
      maxWidth,
      maxHeight,
      success: (result) => {
        // console.log(result);
        resolve(result);
      },
      error(err) {
        reject(err.message);
      },
    });
  });
};

export default {
  name: "templateOne",
  props: {
    componentBoolean: {
      type: Boolean,
      default() {
        return false;
      },
    },
    productId: {
      type: String || Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      identityVerify: {
        obverse: [],
        reverse: [],
        person: [],
      },
      loading: null,
      showArea: false,
      value: "", //地区
      area: {
        receiverProvince: "",
        receiverCity: "",
        receiverCounty: "",
      },
      areaList: [], //城市列表数据
      listContent: ["用户9988", "用户6610", "用户2787", "用户3513"],
      // 表单数据
      order: {
        receiverName: "",
        receiverMobile: "",
        captchaSrc: "",
        code: "",
        smsCode: "",
        receiverAddress: "",
        receiverIdCard: "",
        key: randomNum(24, 16),
      },
      isCountingDown: false,
      countdown: 60,
      countdownTimer: null,
      cityCode: "",
      orderData: {
        minAddressLengthRange: "",
        maxAddressLengthRange: "",
      }, // 页面配置数据
      checked: false, //是否勾选协议
      // 短信
      authTime: "获取验证码",
      // 协议
      fixedBtnShow: false,
      transitionOpportune: -1,
      transitionCode: "", // 转换代码
      transitionType: 0, // 转换类型
      fixedFormShow: false,
      submittedRedirectType: 0,
      thirdPartyProductType: 0,
      submittedRedirectImgUrl: "",
      imageJumpLink: "",
      submittedRedirectPopupVisible: false,
      idNumberPictureFlag: null,
      identityCardImageTypes: null,
      personInfoDisabled: false,
      buttonName: false,
      collapseForm: false,
      pageId: "",
      alertVisible: false,
      alertVisibleText: null,
      payVisible: false,
      checkedPay: "1",
      payStatus: false,
      t: null, //提交防抖定时器
      forbidden: false, //提交禁用标志 true：禁用，false：不禁用
      countyList: [], // 区列表
      showDelist: false, // 下架显示
      goodsMasterImageUrl: "", // 商品主图
      // 颜色配置
      currentColorConfig: {
        titleColor: "#000", // 标题颜色
        backgroundColor: "#FFF", // 背景色
        btnColor: "#ff0000", // 按钮颜色
      },
      // 表单配置
      currentFormConfig: {
        fold: 0, // 表单是否折叠
        roll: 0, // 下单滚动信息
        titleCenter: 0, // 标题是否居中
        rollStyle: 1, // 滚动信息样式
      },
      // 功能配置响应式数据
      currentFunctionConfig: {
        suctionBottom: undefined, //吸底按钮
        isOnline: undefined, //是否上架
        btnStatus: undefined, //按钮状态
        funShow: undefined, //显示功能
        isDisplaySalesVolume: false, //是否展示销量
        isFixedSalesVolume: false, //是否固定销量
        salesVolume: undefined, // 销量
        jumpWechat: undefined, // 跳转微信小程序
        complaintFeedback: undefined, // 投诉反馈按钮显示
        myOrders: undefined, // 我的订单按钮显示
        contactService: undefined, // 联系客服按钮显示
      },
      currentTextConfig: {
        isFolding: undefined, // 表单标题
        btnText: undefined, // 按钮文字
      },
      orderConfig: {
        orderPlacedSuccessInfo: undefined, // 下单成功后展示信息
        kefuPhone: undefined, // 客服电话
        imageUrl: undefined, // 弹出图片
        imageLink: undefined, // 图片跳转链接
        orderPlacedFailureJumpMoneyTree: undefined, // 下单失败后
      },
      goodsImageUrls: [], // 详情图
      smsCodeDialogShow: false, // 短信验证码弹窗
    };
  },
  components: {
    IdCardUploadPopupExample,
    AgreementPopup,
    NoticePopup,
    letterOfAgreementPopup,
    personalInformationPopup,
    policyPopup,
  },
  created() {
    this.getData(this.$route.params);
    this.pageId = this.$route.params.id;
    if (
      this.$route.params &&
      (this.$route.params.id === "271283" || this.$route.params.id === "330236")
    ) {
      this.showDelist = true;
    }

    this.$store.commit("setPathName", window.location.pathname);
    this.throttledHandleScroll = this.throttle(this.handleScroll, 100);
  },
  mounted() {
    // 使用节流版本的滚动监听
    window.addEventListener("scroll", this.throttledHandleScroll);
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.throttledHandleScroll);
  },
  methods: {
    // 限制身份证号只能输入数字和字母
    handleIdCardInput(value) {
      // 只保留数字和字母，过滤掉其他字符
      // 身份证格式：前17位数字，最后一位可以是数字或字母X
      this.order.receiverIdCard = value
        .replace(/[^0-9a-zA-Z]/g, "")
        .toUpperCase();
    },
    // 限制手机号只能输入数字
    handleMobileInput(value) {
      // 过滤掉所有非数字字符
      this.order.receiverMobile = value.replace(/\D/g, "");
    },
    handleScroll() {
      // 获取常规按钮元素
      const btnElement = this.$refs.btn; // 这是包含 btn-wrapper 的元素

      if (btnElement) {
        // 获取按钮相对于视窗的位置
        const rect = btnElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // 判断按钮是否在可视区域内
        // 当按钮顶部在屏幕上方且底部在屏幕下方时，认为按钮部分可见
        const isBtnVisible = rect.top < windowHeight && rect.bottom > 0;

        // 如果按钮不可见，则显示吸底按钮
        this.fixedBtnShow = !isBtnVisible;
      }
    },
    // 滚动到表单位置
    scrollToForm() {
      const btnElement = this.$refs.btn;
      if (btnElement) {
        // 使用 scrollIntoView 实现平滑滚动
        btnElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    // 节流函数
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();

        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    },
    // 生成验证码
    async buildCaptcha() {
      try {
        this.order.code = "";
        const res = await loadCaptcha(this.order.key).catch((e) => {
          if (e.toString().indexOf("429") !== -1) {
            this.$toast("获取验证码过于频繁，请1分钟后再试");
          } else {
            this.$toast("加载验证码失败");
          }
          this.order.captchaSrc = "";
        });
        if (!res || res.byteLength <= 100) {
          this.$toast("系统维护中，请稍微再试~");
          return "";
        }

        // 将 ArrayBuffer 转换为 base64
        const blob = new Blob([res], { type: "image/png" });
        const reader = new FileReader();
        reader.onloadend = () => {
          this.order.captchaSrc = reader.result; // 自动生成 data:image/png;base64,xxx
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error(error);
        this.order.captchaSrc = "";
        return "";
      }
    },
    goLink(type) {
      let url = new Map([
        ["order", "/order"],
        ["report", "/report"],
      ]);
      this.$router.push({
        path: url.get(type),
      });
    },
    closeAlertPopup() {
      this.alertVisible = false;
    },
    fixedBtnClick() {
      if (this.fixedFormShow) {
        this.placeOrder();
      } else {
        this.fixedFormShow = true;
      }
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          document.body.scrollTop =
            document.documentElement.scrollTop =
            top =
              0;
          clearInterval(timeTop);
        }
      }, 10);
    },
    clearValue() {
      this.value = "";
      this.area.receiverProvince = "";
      this.area.receiverCity = "";
      this.area.receiverCounty = "";
    },
    placeOrder() {
      // 零元
      console.log("12314546", this.payStatus);
      // console.log('************', this.thirdPartyProductType)
      if (this.payStatus && this.thirdPartyProductType !== 5) {
        this.payVisible = true;
        return;
      } else {
        this.placeOrderTwo();
      }
    },
    // 提交表单进行防抖处理
    placeOrderTwo() {
      // console.log('this.t', this.t);
      if (this.t !== null) {
        clearTimeout(this.t);
        this.t = null;
      }
      this.t = setTimeout(() => {
        if (!this.forbidden) {
          this.submitInfo();
        }
      }, 500);
    },
    // 提交表单信息
    submitInfo() {
      window.localStorage.setItem("yzm", this.order.smsCode);

      if (this.order.receiverName === "") {
        this.$toast("请输入姓名");
        return;
      }
      if (
        this.orderData.idCardRuleSaveVO &&
        this.orderData.idCardRuleSaveVO.haveIdCard
      ) {
        if (!this.order.receiverIdCard) {
          this.$toast("请输入身份证号码");
          return;
        }
        if (
          this.orderData.idCardRuleSaveVO &&
          this.orderData.idCardRuleSaveVO.idCardRequired
        ) {
          const checkCard = checkIdCard(this.order.receiverIdCard);
          if (!checkCard.pass) {
            this.$toast("身份证号格式错误");
            return;
          }
        }
      }
      if (!this.order.receiverMobile) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.order.smsCode) {
        this.$toast("请输入验证码");

        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.order.receiverMobile)) {
        this.$toast("请输入正确的11位手机号");
        return;
      }
      if (
        !this.area.receiverProvince &&
        !this.area.receiverCity &&
        !this.area.receiverCounty
      ) {
        this.$toast("请选择所在地区（省/市/区）");
        return;
      }

      if (!this.order.receiverAddress) {
        this.$toast("请输入详细地址");
        return;
      }
      if (!this.checked) {
        this.$toast("请阅读并同意相关协议");
        return;
      }
      this.forbidden = true;
      const params = {
        receiverName: this.order.receiverName,
        receiverMobile: this.order.receiverMobile,
        receiverIdCard: this.order.receiverIdCard,
        smsCode: this.order.smsCode,
        receiverProvince: this.area.receiverProvince,
        receiverCity: this.area.receiverCity,
        receiverCounty: this.area.receiverCounty,
        receiverAddress: this.order.receiverAddress,
        goodsCode: this.orderData.goodsCode,
      };
      if (this.loading !== null) {
        this.loading.clear();
        this.loading = null;
      }
      this.loading = this.$toast.loading({
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$store.commit("setClickId", window.location.href);
      //确认订单
      submitOrder(params)
        .then((res) => {
          console.log("确认订单的res===>", res);
          if (res.code === 0) {
            this.$toast({
              message: "下单成功",
              duration: 2000,
            });
            const data = JSON.stringify({
              orderNo: res.data.orderNo,
              ...this.orderConfig,
            });
            this.clearFormData();
            this.jsTransform(2).then(() => {
              setTimeout(() => {
                this.forbidden = false;
                this.loading.clear();
                this.loading = null;
                this.$router.push(`/orderSuccess?data=${data}`);
              }, 2000);
            });
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
            });
            this.forbidden = false;
          }
        })
        .catch(() => {
          if (this.loading === null) return;
          this.forbidden = false;
          this.loading.clear();
          this.loading = null;
        });
    },
    clearFormData() {
      this.order.receiverName = "";
      this.order.receiverIdCard = "";
      this.order.receiverMobile = "";
      this.value = "";
      this.order.code = "";
      this.order.smsCode = "";
      this.order.receiverAddress = "";
      this.area.receiverProvince = "";
      this.area.receiverCity = "";
      this.area.receiverCounty = "";
      this.clearValue();
    },
    showRedirectPopup() {
      this.submittedRedirectPopupVisible = true;
    },
    hideRedirectPopup() {
      this.submittedRedirectPopupVisible = false;
    },
    // 提交图片跳转链接
    handleSubmittedImgUrl() {
      if (this.imageJumpLink) {
        window.location.href = this.imageJumpLink;
      }
    },
    jsTransform(opportunity) {
      return new Promise((resolve, reject) => {
        if (
          this?.transitionType !== 1 ||
          this?.transitionOpportune !== opportunity
        ) {
          resolve();
          return;
        }
        if (this.transitionOpportune === 1) {
          eval(this.transitionCode);
          resolve();
          return;
        }
        if (this.transitionOpportune === 2) {
          // 转换代码
          eval(this.transitionCode);
          resolve();
          return;
        }
        resolve();
        return;
      });
    },

    // 根据地区获取接口的地区编号
    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
    onConfirm(values) {
      this.cityCode = values[values.length - 1].code;
      console.log("values", values);
      let value = values;
      this.area.receiverProvince = values[0].name;
      this.area.receiverCity = values[1].name;
      this.area.receiverCounty = values[2].name;
      // 获取接口的地区编号
      let code = this.getKeyByValue(this.countyList, this.area.receiverCounty);
      value[2].code = code;
      this.value = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
    },
    // 获取页面数据
    getData({ id }) {
      this.$store.commit("setClickId", window.location.href);
      getGoodsDetail(id).then((res) => {
        console.log("获取页面配置的res", res);
        const data = res.data;
        this.orderData = data;
        if (data.addressRuleSaveVO.addressLengthRange) {
          this.orderData.minAddressLengthRange =
            data.addressRuleSaveVO.addressLengthRange.split("~")[0];
          this.orderData.maxAddressLengthRange =
            data.addressRuleSaveVO.addressLengthRange.split("~")[1];
        }
        this.goodsMasterImageUrl = data.detailVO.goodsMasterImageUrl;
        this.currentColorConfig = JSON.parse(data.colorConfigJsonVO);
        this.currentFormConfig = JSON.parse(data.formConfigJson);
        this.currentFunctionConfig = JSON.parse(data.functionConfigJsonVO);
        this.orderConfig = JSON.parse(data.orderConfigJsonVO);
        this.currentTextConfig = JSON.parse(data.textConfigJsonVO);
        this.goodsImageUrls = data.detailVO.goodsImageUrls;
        this.transitionType = data.marketConfigVO.transitionType;
        this.transitionType === 1 && eval(data.marketConfigVO.headCode);
        this.transitionOpportune = data.marketConfigVO.transitionOpportune;
        this.transitionCode = data.marketConfigVO.transitionCode;
        this._getAreaList(data.whitelistAreaConfigs);
        console.log("currentFunctionConfig", this.currentFunctionConfig);
        this.jsTransform(1);
      }).catch(() => {
        this.$router.replace({
          path: '/offline',
        });
      });
    },
    // 获取地址列表
    _getAreaList(data) {
      this.countyList = JSON.parse(JSON.stringify(data.county));
      const { province, city, county } = data;
      const province_hash_map = {};
      // debugger
      Object.keys(province).forEach((code) => {
        province_hash_map[code.slice(0, 2)] = {
          value: province[code],
          hasChild: false,
        };
      });
      // console.log('123', province_hash_map)
      Object.keys(city).forEach((code) => {
        if (province_hash_map[code.slice(0, 2)]) {
          province_hash_map[code.slice(0, 2)].hasChild = true;
        }
      });
      Object.keys(province).forEach((code) => {
        if (!province_hash_map[code.slice(0, 2)].hasChild) {
          delete province[code];
        }
      });
      Object.keys(city).forEach((code) => {
        if (!province[code.slice(0, 2) + "0000"]) {
          delete city[code];
        }
      });
      Object.keys(county).forEach((code) => {
        if (!city[code.slice(0, 4) + "00"]) {
          delete county[code];
        }
      });
      // 重新赋值为六位地区编码
      let counter1 = 2;
      let counter2 = 2;
      for (const key in county) {
        // 东莞区下的县级
        if (key.toString().startsWith("441900")) {
          const newKey = 4419 + counter1.toString().padStart(2, "0");
          county[newKey] = county[key];
          delete county[key];
          counter1++;
        }
        // 中山区下的县级
        if (key.toString().startsWith("442000")) {
          const newKey = 4420 + counter2.toString().padStart(2, "0");
          county[newKey] = county[key];
          delete county[key];
          counter2++;
        }
      }
      this.areaList = {
        province_list: province,
        city_list: city,
        county_list: county,
      };
      console.log("this.areaList", this.areaList);
    },
    // 获取短信验证码
    handleGetSmsCode() {
      console.log("key", this.order.key);
      // 验证手机号
      if (!this.order.receiverMobile) {
        this.$toast("请输入手机号");
        return;
      }

      // 手机号格式验证
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.order.receiverMobile)) {
        this.$toast("请输入正确的手机号格式");
        return;
      }
      this.buildCaptcha();
      this.smsCodeDialogShow = true;

      // try {
      //   // 开始倒计时
      //   this.startCountdown();

      //   // 调用发送短信验证码的API
      //   await getPhoneSmsCode({
      //     key: this.order.key,
      //     code: this.order.code,
      //     mobile: this.order.receiverMobile,
      //   });
      //   this.$toast("验证码已发送,请注意查收");
      // } catch (error) {
      //   // 如果发送失败,停止倒计时
      //   this.stopCountdown();
      //   this.$toast("发送验证码失败,请稍后重试");
      // }
    },
    // 图形验证码弹窗确认
    async handleConfirm() {
      // // 验证图形验证码
      if (!this.order.code) {
        this.$toast("请先输入图形验证码");
        return;
      }
      try {
        // 开始倒计时
        this.startCountdown();

        // 调用发送短信验证码的API
        await getPhoneSmsCode({
          key: this.order.key,
          code: this.order.code,
          mobile: this.order.receiverMobile,
        });
        this.$toast("验证码已发送,请注意查收");
      } catch (error) {
        // 如果发送失败,停止倒计时
        this.stopCountdown();
        this.$toast("发送验证码失败,请稍后重试");
      }
      this.smsCodeDialogShow = false;
    },
    // 图形验证码弹窗取消
    handleCancel() {
      this.order.code = "";
      this.smsCodeDialogShow = false;
    },
    // 开始倒计时
    startCountdown() {
      this.isCountingDown = true;
      this.countdown = 60;

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.stopCountdown();
        }
      }, 1000);
    },

    // 停止倒计时
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.isCountingDown = false;
      this.countdown = 60;
    },

    goKf() {
      if (!this.currentFunctionConfig && !this.currentFunctionConfig.kefuUrl)
        return;
      window.location.href = this.currentFunctionConfig.kefuUrl;
    },
    // 协议
    agreementClick() {
      this.$refs.agreementPopup.show();
    },
    // 个人信息收集证明
    noticeClick() {
      this.$refs.noticePopup.show();
    },
    // 隐私政策
    policyClick() {
      this.$refs.policyPopup.show();
    },
    // 单独同意书
    letterOfAgreementClick() {
      this.$refs.letterOfAgreementPopup.show();
    },
    // 个人信息保护政策
    personalInformationClick() {
      this.$refs.personalInformationPopup.show();
    },
  },
};
</script>

<style lang="less" scoped>
.payAlert {
  background-color: #f1f5f8;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    padding: 15px 0;
  }
  .money {
    font-size: 25px;
    font-weight: bold;
    color: #333;
    .unit {
      font-size: 15px;
      font-weight: bold;
    }
  }
  .alertPayPopup {
    background-color: #fff;
    margin: 15px 10px;
    padding: 15px;
    border-radius: 5px;
    .pay-img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
  .payBtnWrapper {
    background-color: #fff;
    padding: 15px;
    border-radius: 5px 5px 0 0;
    .btn {
      width: 100%;
      background-color: #f05963;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      border-radius: 10px;
    }
  }
  /deep/ .van-radio__label--left {
    display: flex;
  }
  /deep/ .van-radio {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
  }
}
.link {
  color: #3d94f6;
  font-weight: normal;
}
.place-an-order {
  min-height: 100%;
  position: relative;
  .homeAction {
    position: fixed;
    right: 0;
    top: 40px;
    .homeActionItem {
      background-color: #000000;
      border-radius: 32px 0 0 32px;
      opacity: 0.8;
      margin-bottom: 15px;
      font-size: 16px;
      color: #fff;
      padding: 6px 10px;
      display: flex;
      align-items: center;
      .homeActionIcon {
        width: 18px;
        height: 18px;
        padding-right: 4px;
      }
    }
  }
  .dialog_content {
    padding: 20px 10px 10px;
    .dialog_code_image {
      width: 100px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #ccc;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .banner {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      border: none;
      vertical-align: bottom;
    }
  }
  .order-wrapper {
    background-color: #fff;
    padding: 10px;
    .carousel {
      height: 40px;
      margin: 10px 0;
      border-radius: 6px;
      padding: 0 10px;
      background-color: #fef7e4;
      display: flex;
      justify-content: space-between;
      .scrollContainer {
        display: flex;
        align-items: center;
        .iconLeft {
          width: 16px;
          height: 16px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
            vertical-align: bottom;
          }
        }
        .scrollRight {
          width: 190px;
          .content {
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            p {
              color: #000;
              span {
                color: red;
              }
            }
          }
        }
      }
      .sales {
        font-size: 12px;
        line-height: 40px;
        span {
          color: red;
        }
      }
    }
    .order {
      padding: 10px 5px;
      border-radius: 4px;
      background-color: #fff;
      /deep/ .van-cell__title {
        width: 90px;
      }
      /deep/ .van-field__label {
        margin-right: 5px;
      }
      .goods_title {
        font-weight: 500;
        font-size: 18px;
        margin-bottom: 10px;
        &.text-center {
          text-align: center;
        }
      }
      .code_image {
        width: 82px;
        height: 30px;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .code_btn {
        height: 30px;
        font-size: 9px;
        border-radius: 6px;
      }
      .search-agreement {
        span {
          color: #3d94f6;
        }
      }
    }
  }
  .bottom_banner {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      vertical-align: bottom;
    }
  }
  .alertPopup {
    margin: 0 20px;
    padding: 18px;
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .alertText {
      font-size: 16px;
      font-weight: 500;
      padding: 20px 0;
      text-align: left;
    }
    .btn {
      border-radius: 10px;
    }
  }
  .redirect-img {
    margin: 0 20px;
    padding: 8px;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    position: relative;
    .redirect-img-close {
      position: absolute;
      padding: 4px;
      top: 12px;
      right: 12px;
      color: #fff;
      background-color: #000;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
  .search-check {
    background-color: #fff;
    padding: 15px 10px 15px 18px;
    font-size: 11px;
    color: #666;
    font-weight: 500;
    text-align: justify;
  }
  .btn-wrapper,
  .fixed-btn {
    @keyframes btnPulse {
      0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
      }

      70% {
        transform: scale(1.05);
        box-shadow: 0 0 0 8px rgba(255, 0, 0, 0.3);
      }

      100% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
      }
    }

    display: flex;
    padding: 2px 10% 15px 10%;
    background-color: #fff;

    .place-btn {
      width: 80%;
      height: 40px;
      color: #fff;
      margin: 15px auto;
      border-radius: 50px;
      border: 1px solid red;
      background-color: red;

      &.btn-animate {
        animation: btnPulse 1.5s ease-in-out infinite;
      }
    }
  }
  .place-bottom-img {
    width: 100%;
    // height: 100%;
  }
}
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-cell__title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
}
::v-deep .van-button--primary {
  background-color: #fff;
  color: #d41010;
  border: 1px solid #ecbcbc;
}
:v-deep .van-dialog {
  border-radius: 8px;
}
.fixed-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  z-index: 9999;
  padding: 0 !important;
  background-color: transparent !important;
  display: flex;
  align-items: center;
}
</style>
